import { Request } from "../../utils/request";

export const fetchMatters = () => Request({ withToken: true }).get("/matters");
